import React from 'react';
import { observer } from 'mobx-react-lite';
import Form from 'mobx-react-form';

import {
  Grid,
  Typography,
  Paper,
  Stack,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

import { STATES_LIST_SHORT } from '../constants';
import SiteArea from './SiteArea';
import NumericInput from 'components/shared/inputs/NumericInput';

type SiteDetailsProps = {
  form: Form;
};

const SiteDetails = observer(({ form }: SiteDetailsProps) => {
  return (
    <Paper elevation={0}>
      <Typography variant="h6">Site Details</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            {...form.$('property.address.street').bind()}
            size="small"
            margin="normal"
            label="Street Address"
            fullWidth
          />
          <TextField
            {...form.$('property.address.neighborhood').bind()}
            size="small"
            margin="normal"
            label="Neighborhood/District"
            fullWidth
          />
          <TextField {...form.$('property.address.city').bind()} size="small" margin="normal" label="City" fullWidth />
          <TextField
            {...form.$('property.address.county').bind()}
            size="small"
            margin="normal"
            label="County"
            fullWidth
          />
          <TextField
            {...form.$('property.address.zip').bind()}
            size="small"
            margin="normal"
            label="Zip Code"
            fullWidth
          />
          <FormControl margin="normal">
            <InputLabel id="state-select-label">State</InputLabel>
            <Select
              {...form.$('property.address.state').bind()}
              displayEmpty
              labelId="state-select-label"
              label="State"
              size="small"
              sx={{ minWidth: '100px' }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250,
                  },
                },
              }}
            >
              {STATES_LIST_SHORT.map(({ label, value }) => (
                <MenuItem key={value} value={label}>
                  {label || value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Stack direction="row" sx={{ gap: '16px' }}>
            <NumericInput
              {...form.$('property.coords.latitude').bind()}
              size="small"
              margin="normal"
              label="Latitude"
              fullWidth
              decimalScale={5}
            />
            <NumericInput
              {...form.$('property.coords.longitude').bind()}
              size="small"
              margin="normal"
              label="Longitude"
              fullWidth
              decimalScale={5}
            />
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <SiteArea form={form} />
          <NumericInput
            {...form.$('property.yearBuilt').bind()}
            size="small"
            margin="normal"
            label="Year Built"
            fullWidth
            decimalScale={0}
            allowNegative={false}
          />
          <FormControlLabel
            control={<Checkbox {...form.$('property.isYearBuiltEstimate').bind()} />}
            label="This is an estimate."
          />
          <NumericInput
            {...form.$('property.yearRenovated').bind()}
            size="small"
            margin="normal"
            label="Year Renovated"
            fullWidth
            decimalScale={0}
            allowNegative={false}
          />
        </Grid>
      </Grid>
    </Paper>
  );
});

export { SiteDetails };
